/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ThreePersonsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <circle cx="4" cy="10.5" r="2" />
      <path d="M4,14.5 L7.5,14.5 C7.5,17.163 7.25,19 5.5,19.45 L5.5,23.5 L4,23.5 L2.5,23.5 L2.5,19.45 C0.75,19 0.5,17.163 0.5,14.5 L4,14.5 Z" />
      <circle cx="20" cy="10.5" r="2" />
      <path d="M20,14.5 L23.5,14.5 C23.5,17.163 23.25,19 21.5,19.45 L21.5,23.5 L20,23.5 L18.5,23.5 L18.5,19.45 C16.75,19 16.5,17.163 16.5,14.5 L20,14.5 Z" />
      <circle cx="12" cy="2.5" r="2" />
      <path d="M12,6.5 L15.5,6.5 C15.5,9.163 15.25,11 13.5,11.45 L13.5,15.5 L12,15.5 L10.5,15.5 L10.5,11.45 C8.75,11 8.5,9.163 8.5,6.5 L12,6.5 Z" />
    </g>
  </svg>
);

export default ThreePersonsIcon;
